const initActions = (services) => {
    const axiosCall = services.axios.Axios();

    const getAllApps = () => async () => axiosCall.get('apps');

    const fetchApps = () => {
        return async () => {
            try {
                var response = await axiosCall.get('apps');
                return response.data;
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    return {
        getAllApps,
        fetchApps,
    }
};

export default initActions;